import { useSelector } from 'react-redux';
import {
  selectRoutesMode,
  selectSelectedRouteId,
  selectRoutesTempLabel,
  selectRoutesTempStops,
  selectIsLoadingDirections,
  selectRoutesDirections,
  selectDirectionsError,
  selectRouteVisibility,
  selectCanSaveRoute,
} from 'src/redux';
import type {
  EnrichedRouteStop,
  RouteDirections,
  RouteEditorMode,
} from './types';

export interface UseRouteStateReturn {
  mode: RouteEditorMode;
  selectedRouteId: string | null;
  tempLabel: string;
  tempStops: EnrichedRouteStop[];
  directions: RouteDirections | null;
  isLoadingDirections: boolean;
  directionsError: string | null;
  routeVisibility: Record<string, boolean>;
  // Derived
  isCreating: boolean;
  isEditing: boolean;
  isViewing: boolean;
  canSave: boolean;
}

const useRouteState = (): UseRouteStateReturn => {
  const mode = useSelector(selectRoutesMode);
  const selectedRouteId = useSelector(selectSelectedRouteId);
  const tempLabel = useSelector(selectRoutesTempLabel);
  const tempStops = useSelector(selectRoutesTempStops);
  const isLoadingDirections = useSelector(selectIsLoadingDirections);
  const directions = useSelector(selectRoutesDirections);
  const directionsError = useSelector(selectDirectionsError);
  const routeVisibility = useSelector(selectRouteVisibility);
  const canSave = useSelector(selectCanSaveRoute);

  const isCreating = mode === 'creating';
  const isEditing = mode === 'editing';
  const isViewing = mode === 'viewing';

  return {
    mode,
    selectedRouteId,
    tempLabel,
    tempStops,
    directions,
    isLoadingDirections,
    directionsError,
    routeVisibility,
    isCreating,
    isEditing,
    isViewing,
    canSave,
  };
};

export default useRouteState;
